var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChequeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    viewBox: "0 0 2.833 2.833",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 2.833,
    y1: 1.417,
    y2: 1.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#26a9e0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#2297d3",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#1e84c6",
    offset: 0.231
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#1c79be",
    offset: 0.369
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#1b75bb",
    offset: 0.522
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#2b388f",
    offset: 0.961
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1.417,
    cy: 1.417,
    r: 1.417,
    fill: "url(#a)",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2.23 1.872H.603a.04.04 0 0 1-.04-.04v-.831a.04.04 0 0 1 .04-.04H2.23a.04.04 0 0 1 .04.04v.831a.04.04 0 0 1-.04.04zm-.28-.228c.008 0 .018-.002.026-.004a.027.027 0 0 0-.013-.052.07.07 0 0 1-.011.002h-.008l-.004-.005-.006-.009a.12.12 0 0 0-.088-.062c-.041-.008-.067.002-.098.027l-.008.006-.006.005-.007-.003a.15.15 0 0 1-.034-.028c-.027-.027-.063-.048-.102-.032a.08.08 0 0 0-.02.011.109.109 0 0 0-.018.02.2.2 0 0 0-.035.094c0 .015.012.027.027.027s.026-.012.026-.027c.002-.02.02-.068.041-.076.015-.005.034.012.043.021.022.022.056.051.09.044a.094.094 0 0 0 .037-.02c.019-.016.029-.021.053-.017.029.006.04.015.054.038.015.025.03.04.06.04zm.098.102a.027.027 0 1 0 0-.053h-.581a.027.027 0 1 0 0 .053zm-.557-.382a.027.027 0 1 0 0-.054h-.482a.027.027 0 1 0 0 .054zm.397-.182a.027.027 0 0 0 0-.053h-.879a.027.027 0 0 0 0 .053h.879zm-1.113.417a.027.027 0 1 0-.053 0c0 .048.033.089.077.1v.018a.027.027 0 1 0 .053 0V1.7a.104.104 0 0 0 .078-.101c0-.068-.04-.09-.098-.103-.035-.009-.057-.012-.057-.052a.05.05 0 0 1 .101 0 .027.027 0 1 0 .054 0 .104.104 0 0 0-.078-.1v-.018a.027.027 0 1 0-.053 0v.018a.104.104 0 0 0-.077.1c0 .068.04.09.098.104.034.008.056.011.056.051a.05.05 0 0 1-.1 0z",
    opacity: 1,
    "data-original": "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChequeIcon);
export default __webpack_public_path__ + "static/media/cheque_icon.f56dae8e83fb39bbb4d04171e8f35e79.svg";
export { ForwardRef as ReactComponent };